/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  // },
  {
    url: null,
    name: "Dashboard",
    tag: "2",
    tagColor: "warning",
    icon: "HomeIcon",
    submenu: [
      {
        url: '/dashboard/analytics',
        name: "Analytics",
        slug: "dashboard-analytics",
      },
      {
        url: '/dashboard/ecommerce',
        name: "eCommerce",
        slug: "dashboard-ecommerce",
      },
    ]
  },
  {
    header: "Apps",
    icon: "PackageIcon",
    items: [
      {
        url: null,
        name: "Competitions",
        icon: "GiftIcon",
        submenu: [
          {
            url: '/apps/competition/competition-list',
            name: "List",
            slug: "app-competition-list",
          },
        ]
      },
      {
        url: "/apps/email",
        name: "Email",
        slug: "email",
        icon: "MailIcon",
      },
      {
        url: "/apps/chat",
        name: "Chat",
        slug: "chat",
        icon: "MessageSquareIcon",
      },
      {
        url: "/apps/todo",
        name: "Todo",
        slug: "todo",
        icon: "CheckSquareIcon",
      },
      {
        url: "/apps/calendar/vue-simple-calendar",
        name: "Calendar",
        slug: "calendar-simple-calendar",
        icon: "CalendarIcon",
        tagColor: "success",
      },
      {
        url: null,
        name: "eCommerce",
        icon: "ShoppingCartIcon",
        submenu: [
          {
            url: '/apps/eCommerce/shop',
            name: "Shop",
            slug: "ecommerce-shop",
          },
          {
            url: '/apps/eCommerce/item/',
            name: "Item Details",
            slug: "ecommerce-item-detail-view",
          },
          {
            url: '/apps/eCommerce/wish-list',
            name: "Wish List",
            slug: "ecommerce-wish-list",
          },
          {
            url: '/apps/eCommerce/checkout',
            name: "Checkout",
            slug: "ecommerce-checkout",
          },
        ]
      },
      {
        url: null,
        name: "User",
        icon: "UserIcon",
        submenu: [
          {
            url: '/apps/user/user-list',
            name: "List",
            slug: "app-user-list",
          },
          {
            url: '/apps/user/user-view/268',
            name: "View",
            slug: "app-user-view",
          },
          {
            url: '/apps/user/user-edit/268',
            name: "Edit",
            slug: "app-user-edit",
          },
        ]
      },
    ]
  },
  {
    header: "UI",
    icon: "LayersIcon",
    items: [
      {
        url: null,
        name: "Data List",
        tag: "new",
        tagColor: "primary",
        icon: "ListIcon",
        submenu: [
          {
            url: '/ui-elements/data-list/list-view',
            name: "List View",
            slug: "data-list-list-view",
          },
          {
            url: '/ui-elements/data-list/thumb-view',
            name: "Thumb View",
            slug: "data-list-thumb-view",
          },
        ]
      },
      {
        url: null,
        name: "Grid",
        icon: "LayoutIcon",
        submenu: [
          {
            url: '/ui-elements/grid/vuesax',
            name: "Vuesax",
            slug: "grid-vuesax",
          },
          {
            url: '/ui-elements/grid/tailwind',
            name: "Tailwind",
            slug: "grid-tailwind",
          },
        ]
      },
      {
        url: "/ui-elements/colors",
        name: "Colors",
        slug: "colors",
        icon: "DropletIcon",
      },
      {
        url: null,
        name: "Card",
        icon: "CreditCardIcon",
        submenu: [
          {
            url: '/ui-elements/card/basic',
            name: "Basic",
            slug: "basic-cards",
          },
          {
            url: '/ui-elements/card/statistics',
            name: "Statistics",
            slug: "statistics-cards",
          },
          {
            url: '/ui-elements/card/analytics',
            name: "Analytics",
            slug: "analytics-cards",
          },
          {
            url: '/ui-elements/card/card-actions',
            name: "Card Actions",
            slug: "card-actions",
          },
          {
            url: '/ui-elements/card/card-colors',
            name: "Card Colors",
            slug: "card-colors",
          }
        ]
      },
      {
        url: null,
        name: "Components",
        icon: "ArchiveIcon",
        submenu: [
          {
            url: '/components/alert',
            name: "Alert",
            slug: "component-alert",
          },
          {
            url: '/components/avatar',
            name: "Avatar",
            slug: "component-avatar",
          },
          {
            url: '/components/breadcrumb',
            name: "Breadcrumb",
            slug: "component-breadcrumb",
          },
          {
            url: '/components/button',
            name: "Button",
            slug: "component-button",
          },
          {
            url: '/components/button-group',
            name: "Button Group",
            slug: "component-button-group",
          },
          {
            url: '/components/chip',
            name: "Chip",
            slug: "component-chip",
          },
          {
            url: '/components/collapse',
            name: "Collapse",
            slug: "component-collapse",
          },
          {
            url: '/components/dialogs',
            name: "Dialogs",
            slug: "component-dialog",
          },
          {
            url: '/components/divider',
            name: "Divider",
            slug: "component-divider",
          },
          {
            url: '/components/dropdown',
            name: "DropDown",
            slug: "component-drop-down",
          },
          {
            url: '/components/list',
            name: "List",
            slug: "component-list",
          },
          {
            url: '/components/loading',
            name: "Loading",
            slug: "component-loading",
          },
          {
            url: '/components/navbar',
            name: "Navbar",
            slug: "component-navbar",
          },
          {
            url: '/components/notifications',
            name: "Notifications",
            slug: "component-notifications",
          },
          {
            url: '/components/pagination',
            name: "Pagination",
            slug: "component-pagination",
          },
          {
            url: '/components/popup',
            name: "Popup",
            slug: "component-popup",
          },
          {
            url: '/components/progress',
            name: "Progress",
            slug: "component-progress",
          },
          {
            url: '/components/sidebar',
            name: "Sidebar",
            slug: "component-sidebar",
          },
          {
            url: '/components/slider',
            name: "Slider",
            slug: "component-slider",
          },
          {
            url: '/components/tabs',
            name: "Tabs",
            slug: "component-tabs",
          },
          {
            url: '/components/tooltip',
            name: "Tooltip",
            slug: "component-tooltip",
          },
          {
            url: '/components/upload',
            name: "Upload",
            slug: "component-upload",
          },
        ]
      },
      {
        url: null,
        name: "Extensions",
        icon: "PlusCircleIcon",
        submenu: [
          {
            url: '/extensions/select',
            name: "Select",
            icon: "PocketIcon",
            slug: "extra-component-select",
          },
          {
            url: '/extensions/quill-editor',
            name: "Quill Editor",
            icon: "EditIcon",
            slug: "extra-component-quill-editor",
          },
          {
            url: '/extensions/drag-and-drop',
            name: "Drag & Drop",
            icon: "DropletIcon",
            slug: "extra-component-drag-and-drop",
          },
          {
            url: '/extensions/datepicker',
            name: "Datepicker",
            icon: "CalendarIcon",
            slug: "extra-component-datepicker",
          },
          {
            url: '/extensions/datetime-picker',
            name: "Datetime Picker",
            icon: "ClockIcon",
            slug: "extra-component-datetime-picker",
          },
          {
            url: '/extensions/access-control',
            name: "Access Control",
            slug: "extra-component-access-control",
          },
          {
          },
          {
            url: '/extensions/carousel',
            name: "Carousel",
            icon: "LayersIcon",
            slug: "extra-component-carousel",
          },
          {
            url: '/extensions/clipboard',
            name: "Clipboard",
            icon: "CopyIcon",
            slug: "extra-component-clipboard",
          },
          {
            url: '/extensions/context-menu',
            name: "Context Menu",
            icon: "MoreHorizontalIcon",
            slug: "extra-component-context-menu",
          },
          {
            url: '/extensions/star-ratings',
            name: "Star Ratings",
            icon: "StarIcon",
            slug: "extra-component-star-ratings",
          },
          {
            url: '/extensions/autocomplete',
            name: "Autocomplete",
            icon: "Edit3Icon",
            slug: "extra-component-autocomplete",
          },
          {
            url: '/extensions/tree',
            name: "Tree",
            icon: "GitPullRequestIcon",
            slug: "extra-component-tree",
          },
          // {
          //   name: "Import/Export",
          //   submenu: [

          //   ]
          // },
          {
            url: "/import-export/import",
            name: "Import",
            icon: "HomeIcon",
            slug: "import",
          },
          {
            url: "/import-export/export",
            name: "Export",
            icon: "HomeIcon",
            slug: "export",
          },
          {
            url: "/import-export/export-selected",
            name: "Export Selected",
            icon: "HomeIcon",
            slug: "export-selected",
          }
        ]
      },
    ]
  },
  {
    header: "Forms & Table",
    icon: "Edit3Icon",
    items: [
      {
        url: null,
        name: "Form Elements",
        icon: "CopyIcon",
        submenu: [
          // {
          //  url: '/forms/form-elements/select',
          //  name: "Select",
          //  slug: "form-element-select",
          // },
          {
            url: '/forms/form-elements/switch',
            name: "Switch",
            slug: "form-element-switch",
          },
          {
            url: '/forms/form-elements/checkbox',
            name: "Checkbox",
            slug: "form-element-checkbox",
          },
          {
            url: '/forms/form-elements/radio',
            name: "Radio",
            slug: "form-element-radio",
          },
          {
            url: '/forms/form-elements/input',
            name: "Input",
            slug: "form-element-input",
          },
          {
            url: '/forms/form-elements/number-input',
            name: "Number Input",
            slug: "form-element-number-input",
          },
          {
            url: '/forms/form-elements/textarea',
            name: "Textarea",
            slug: "form-element-textarea",
          },
        ]
      },
      {
        url: '/forms/form-layouts',
        name: "Form Layouts",
        icon: "PackageIcon",
        slug: "forms-form-layouts",
      },
      {
        url: '/forms/form-wizard',
        name: "Form Wizard",
        icon: "PackageIcon",
        slug: "extra-component-form-wizard",
      },
      {
        url: '/forms/form-validation',
        name: "Form Validation",
        icon: "CheckCircleIcon",
        slug: "extra-component-form-validation",
      },
      {
        url: '/forms/form-input-group',
        name: "Form Input Group",
        icon: "MenuIcon",
        slug: "extra-component-form-input-group",
      },
      {
        url: "/ui-elements/table",
        name: "Table",
        slug: "table",
        icon: "GridIcon",
      },
      {
        url: "/ui-elements/ag-grid-table",
        name: "agGrid Table",
        slug: "ag-grid-table",
        icon: "GridIcon",
      },
    ]
  },
  {
    header: "Pages",
    icon: "FileIcon",
    items: [
      {
        url: '/pages/profile',
        slug: 'page-profile',
        name: "Profile",
        icon: "UserIcon",
      },
      {
        url: '/pages/user-settings',
        slug: 'page-user-settings',
        name: "User Settings",
        icon: "SettingsIcon",
      },
      {
        url: '/pages/faq',
        slug: 'page-faq',
        name: "FAQ",
        icon: "HelpCircleIcon",
      },
      {
        url: '/pages/knowledge-base',
        slug: 'page-knowledge-base',
        name: "Knowledge Base",
        icon: "InfoIcon",
      },
      {
        url: '/pages/search',
        slug: 'page-search',
        name: "Search",
        icon: "SearchIcon",
      },
      {
        url: '/pages/invoice',
        slug: 'page-invoice',
        name: "Invoice",
        icon: "InfoIcon",
      },
      {
        url: null,
        name: "Authentication",
        icon: "PieChartIcon",
        submenu: [
          {
            url: '/pages/login',
            name: "Login",
            slug: "pages-login",
            target: '_blank',
          },
          {
            url: '/pages/register',
            name: "Register",
            slug: "pages-register",
            target: '_blank',
          },
          {
            url: '/pages/forgot-password',
            name: "Forgot Password",
            slug: "pages-forgot-password",
            target: '_blank',
          },
          {
            url: '/pages/reset-password',
            name: "Reset Password",
            slug: "pages-reset-password",
            target: '_blank',
          },
          {
            url: '/pages/lock-screen',
            name: "Lock Screen",
            slug: "pages-lock-screen",
            target: '_blank',
          },
        ]
      },
      {
        url: null,
        name: "Miscellaneous",
        icon: "CoffeeIcon",
        submenu: [
          {
            url: '/pages/not-authorized',
            name: "Not Authorized",
            slug: "page-not-authorized",
            icon: "XCircleIcon",
            target: '_blank',
          },
          {
            url: '/pages/maintenance',
            name: "Maintenance",
            slug: "page-maintenance",
            icon: "AnchorIcon",
            target: '_blank',
          },
          {
            url: '/pages/comingsoon',
            slug: 'page-coming-soon',
            name: "Coming Soon",
            icon: "ClockIcon",
            target: '_blank',
          },
          {
            url: '/pages/error-404',
            name: "404",
            slug: "page-error-404",
            target: '_blank',
          },
          {
            url: '/pages/error-500',
            name: "500",
            slug: "page-error-500",
            target: '_blank',
          }
        ]
      },
    ]
  },
  {
    header: "Charts & Maps",
    icon: "PieChartIcon",
    items: [
      {
        url: null,
        name: "Charts",
        icon: "PieChartIcon",
        tag: '3',
        tagColor: 'success',
        submenu: [
          {
            url: '/charts-and-maps/charts/apex-charts',
            name: "Apex Charts",
            slug: "extra-component-charts-apex-charts",
          },
          {
            url: '/charts-and-maps/charts/chartjs',
            name: "chartjs",
            slug: "extra-component-charts-chartjs",
          },
          {
            url: '/charts-and-maps/charts/echarts',
            name: "echarts",
            slug: "extra-component-charts-echarts",
          },
        ]
      },
      {
        url: '/charts-and-maps/maps/google-map',
        name: "Google Map",
        icon: "MapIcon",
        slug: "extra-component-maps-google-map",
      },
    ]
  },
  {
    header: "Others",
    icon: "MoreHorizontalIcon",
    items: [
      {
        url: null,
        name: "Menu Levels",
        icon: "MenuIcon",
        submenu: [
          {
            url: null,
            name: "Menu Level 2.1",
          },
          {
            url: null,
            name: "Menu Level 2.2",
            submenu: [
              {
                url: null,
                name: "Menu Level 3.1",
              },
              {
                url: null,
                name: "Menu Level 3.2",
              },
            ]
          },
        ]
      },
      {
        url: null,
        name: "Disabled Menu",
        icon: "EyeOffIcon",
        isDisabled: true,
      },
      {
        url: null,
        name: "Support",
        icon: "SmileIcon",
        submenu: [
          {
            url: 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/',
            name: "Documentation",
            icon: "BookOpenIcon",
            slug: "external",
            target: "_blank"
          },
          {
            url: 'https://pixinvent.ticksy.com/',
            name: "Raise Support",
            icon: "LifeBuoyIcon",
            slug: "external",
            target: "_blank"
          },
        ]
      },
    ]
  },
]

